import { render, staticRenderFns } from "./sds-field.vue?vue&type=template&id=45cfecaf"
import script from "./sds-field.vue?vue&type=script&lang=js"
export * from "./sds-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports